import { Button, Stack, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useYesNoDialog } from "./dialog/YesNoDialog";
import { Icons } from "../image/Icons";
import { VoidAction } from "../util/func";
import { getHexCode } from "../util/Color";
import StyledButton from "./StyledButton";
import { useDeviceClass, ui } from "../util/responsive";

export function HomeButton({ onBackHome }: { onBackHome?: VoidAction }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [yesNoDialog, showYesNoDialog] = useYesNoDialog();
  const d = useDeviceClass();

  const returnToHome = () => {
    if (onBackHome) {
      onBackHome();
    }
    navigate("/console/")
  }

  const tryReturnToHome = () => {
    const path = location.pathname;
    if (path.endsWith("/edit/") || path.endsWith("/new/")) {
      showYesNoDialog({
        title: "ホームに戻りますか？",
        text: "現在入力中の情報はすべて失われます。",
        onConfirm: returnToHome,
      });
    } else if (path.endsWith("/process/")) {
      showYesNoDialog({
        title: "ホームに戻りますか？",
        text: "現在の作業をキャンセルしてホームに戻ります。\n※現在作業中の情報はすべて失われます。",
        onConfirm: returnToHome,
      });
    }  else {
      returnToHome()
    }
  }

  return (
    <Stack width={ui.homeIcon[d]}>
      <Button style={{ border: "none", minWidth: 0, padding: 0 }} onClick={tryReturnToHome}>
        <img width={ui.homeIcon[d]} height={ui.homeIcon[d]} src={Icons.OkumuraIcon} />
      </Button>
      {yesNoDialog}
    </Stack>
  );
}

export function ReloadButton() {
  const location = useLocation();
  const [yesNoDialog, showYesNoDialog] = useYesNoDialog();
  const d = useDeviceClass();

  const tryReload = () => {
    const path = location.pathname;
    if (path.endsWith("/edit/") || path.endsWith("/new/")) {
      showYesNoDialog({
        title: "ページを再読み込みしますか？",
        text: "現在入力中の情報はすべて失われます。",
        onConfirm: () => window.location.reload(),
      });
    } else if (path.endsWith("/process/")) {
      showYesNoDialog({
        title: "ページを再読み込みしますか？",
        text: "現在の作業をキャンセルしてページを再読み込みします。\n※現在作業中の情報はすべて失われます。",
        onConfirm: () => window.location.reload(),
      });
    } else {
      window.location.reload();;
    }
  }

  return (
    <Stack pl={1}>
      <StyledButton buttonStyle="bordered" onClick={tryReload}>
        <Stack direction="row" alignItems="center" gap={1}>
          <img width={ui.reloadIcon[d]} height={ui.reloadIcon[d]} src={Icons.ReloadIcon} />
          <Typography fontSize={ui.reloadFont[d]} whiteSpace="none" noWrap color={getHexCode("White")}>更新</Typography>
        </Stack>
      </StyledButton>
      {yesNoDialog}
    </Stack>
  );
}
